import { ColumnDef } from '@tanstack/react-table';
import { get } from 'lodash';
import { useMemo } from 'react';

import {
  BasicTableColumn,
  FilterType,
} from '@work4all/components/lib/dataDisplay/basic-table';

import { wrapV7Cell } from '../../wrap-v7-cell';

export function useColumnDefs<T = Record<string, any>>(
  columns: BasicTableColumn[]
) {
  return useMemo(() => {
    const columnDefs: ColumnDef<T, any>[] = columns.map((column) => {
      const columnDef: ColumnDef<T, any> = {
        ...column,
        id: column.id,
        accessorFn:
          typeof column.accessor === 'function'
            ? (column.accessor as any)
            : (info) => get(info, column.accessor as string),
        accessorKey:
          typeof column.accessor === 'string' ? column.accessor : undefined,
        size: typeof column.width === 'number' ? column.width : undefined,
        minSize:
          typeof column.minWidth === 'number' ? column.minWidth : undefined,
        maxSize:
          typeof column.maxWidth === 'number' ? column.maxWidth : undefined,
        cell: wrapV7Cell(column.Cell),
        header: column.Header,
        enableSorting: !column.disableSortBy,
        enableHiding: !column.disableColumnVisibility,

        footer: column.Footer,

        enableGrouping: !column.disableGroupBy,
        sortDescFirst: false,
        enableColumnFilter: !column.disableFilters,
        enableGlobalFilter: column.quickSearchable,
        groupLabelElement: column.GroupLabelElement,
        groupLabelElementParams: column.groupLabelElementParams,
        enableResizing: !column.disableResizing,

        filterFn: (() => {
          switch (column.filterType) {
            case FilterType.ClosedStatus:
              return 'closedStatus';
            case FilterType.Search:
              return 'complexSearch';
            default:
              return 'equals';
          }
        })(),
      };

      // Remove all undefined properties from the columnDef object
      Object.keys(columnDef).forEach((key) => {
        if (columnDef[key] === undefined) {
          delete columnDef[key];
        }
      });

      return columnDef;
    });

    return columnDefs;
  }, [columns]);
}
